import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import useForSomeoneElse from '../../hooks/useForSomeoneElse';
import useSetForSomeoneElse from '../../hooks/useSetForSomeoneElse';
import useSetSelfRating from '../../hooks/useSetSelfRating';
import useSetWizardStep from '../../hooks/useSetWizardStep';
import useWizardContext from '../../hooks/useWizardContext';
import { WizardStep } from '../../types/Wizard';
import classes from './classes.module.css';

const SelfRating: React.FC = () => {
  const intl = useIntl();
  const forSomeoneElse = useForSomeoneElse();
  const setForSomeoneElse = useSetForSomeoneElse();
  const setSelfRating = useSetSelfRating();
  const setStep = useSetWizardStep();
  const ctx = useWizardContext();
  useEffect(()=>{
    if (ctx.appointmentType?.id != '35f42b66-7450-4df4-9226-63a49d9cde78') {
      setStep((prev) => (prev + 1) as WizardStep);
    }
  })

  const handleToggle = (toggle: boolean) => () => {
    setForSomeoneElse(toggle);
  };
  const handleConfirmation = (number: number) => () => {
    setSelfRating(number);
    if (number && number >= 8) {
      const url = 'https://hearing-screener.beyondhearing.org/schoonenberg/ed7YLT/';
      window.location.assign(url);
    } else {
      setStep((prev) => (prev + 1) as WizardStep);
    }
  };
  const buttonColors = [
    classes.color1,
    classes.color2,
    classes.color3,
    classes.color4,
    classes.color5,
    classes.color6,
    classes.color7,
    classes.color8,
    classes.color9,
    classes.color10,
  ];
  const buttonList = buttonColors.map((color, index) => (
    <button type='button' className={color} key={index} onClick={handleConfirmation(index + 1)}>
      {index + 1}
    </button>
  ));
  return (
    <div className={classes.outer}>
      <div className={classes.container}>
        <div className={classes.upper}>
          <h2>{intl.formatMessage({ id: 'selfRating.title' })}</h2>
        </div>
        <div className={classes.lower}>
          <div className={classes.buttons}>
            <button
              type='button'
              className={forSomeoneElse ? classes.button : classes.selectedButton}
              onClick={handleToggle(false)}
            >
              {intl.formatMessage({ id: 'selfRating.forMyself' })}
            </button>
            <button
              type='button'
              className={forSomeoneElse ? classes.selectedButton : classes.button}
              onClick={handleToggle(true)}
            >
              {intl.formatMessage({ id: 'selfRating.forSomeoneElse' })}
            </button>
          </div>
          <div className={classes.description}>
            {forSomeoneElse
              ? intl.formatMessage({ id: 'selfRating.description.forSomeoneElse' })
              : intl.formatMessage({ id: 'selfRating.description.forMyself' })}
          </div>
          <div className={classes.ratingSlider}>
            <div className={classes.ratingButtons}>
              <div className={classes.responsiveBad}>{intl.formatMessage({ id: 'selfRating.slider.bad' })}</div>
              {buttonList}
            </div>
            <div className={classes.responsiveGood}>{intl.formatMessage({ id: 'selfRating.slider.good' })}</div>
            <div className={classes.sliderText}>
              <p className={classes.sliderBad}>{intl.formatMessage({ id: 'selfRating.slider.bad' })}</p>
              <p className={classes.sliderGood}>{intl.formatMessage({ id: 'selfRating.slider.good' })}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
SelfRating.displayName = 'SelfRating';

export default SelfRating;
